import React from 'react';

const Error = ({ error, message }) => {
  const errorMessage = error || message || 'Nastala neocekavana chyba';

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 p-4 flex justify-center items-center">
      <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-lg border-l-4 border-red-500">
        <div className="text-5xl mb-6">
          <span role="img" aria-label="warning">⚠️</span>
        </div>
        <h2 className="text-2xl font-bold text-red-500 mb-4">
          Chyba pri nacitani
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          {errorMessage}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="py-3 px-8 text-lg font-semibold bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all"
        >
          Zkusit znovu
        </button>
      </div>
    </div>
  );
};

export default Error;
